export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network Roles"])},
        "new_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Role"])},
        "delete_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Role"])},
        "delete_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to delete this role?"])}
      },
      "fr": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rôles du réseau"])},
        "new_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau rôle"])},
        "delete_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le rôle"])},
        "delete_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voulez-vous vraiment supprimer ce rôle?"])}
      }
    }
  })
}